import get from 'lodash.get';
import type { FeedEntry, UIComponent } from '~/services/layout';
import { ActionRegistry } from '../actions/ActionRegistry';
import type { Action } from '../actions/types';

export const getSelectedCell = ({
  isPreferenceEditor,
  selected,
  feedEntryExtensionsTag,
  behaviorCurrentSelection,
  isBehaviorMultiActionFeedEntry,
}: {
  isPreferenceEditor: boolean;
  selected: string;
  feedEntryExtensionsTag: string | undefined;
  behaviorCurrentSelection: string | undefined;
  isBehaviorMultiActionFeedEntry: boolean;
}) => {
  if (isBehaviorMultiActionFeedEntry) {
    return behaviorCurrentSelection === feedEntryExtensionsTag;
  }

  return isPreferenceEditor && selected === feedEntryExtensionsTag;
};

export const getUnselectedCell = ({
  isPreferenceEditor,
  selected,
  feedEntryExtensionsTag,
  behaviorCurrentSelection,
  isBehaviorMultiActionFeedEntry,
}: {
  isPreferenceEditor: boolean;
  selected: string;
  feedEntryExtensionsTag: string | undefined;
  behaviorCurrentSelection: string | undefined;
  isBehaviorMultiActionFeedEntry: boolean;
}) => {
  if (isBehaviorMultiActionFeedEntry) {
    return behaviorCurrentSelection !== feedEntryExtensionsTag;
  }

  return isPreferenceEditor && selected !== feedEntryExtensionsTag;
};

export const selectParentEntryExtensions = (entry: FeedEntry) =>
  get(entry, '_extensions');

export const selectEntryParentBehavior = (
  entry: FeedEntry
): {
  selectMode: 'single' | 'multiple' | undefined;
  currentSelection: string | undefined;
} => {
  return {
    selectMode: get(selectParentEntryExtensions(entry), 'behavior.select_mode'),
    currentSelection: get(
      selectParentEntryExtensions(entry),
      'behavior.current_selection'
    ),
  };
};

export const selectEntryParentPreferenceEditorOptions = (entry: FeedEntry) => {
  return get(selectParentEntryExtensions(entry), 'preference_editor_options');
};

export const executeCellActions = (
  tapActionsExtension: { actions?: Action[] } | null | undefined,
  context: { feedEntry: FeedEntry; uiComponent: UIComponent }
) => {
  const actions = tapActionsExtension?.actions;
  if (!Array.isArray(actions)) return;

  ActionRegistry.getInstance().execute(actions, { context });
};
